import { Component, OnInit } from '@angular/core';
import { AuditService } from '../rest_services/audit.service';

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.css']
})
export class AuditComponent implements OnInit {

  alltraces:any[]=[];
  auditLoading:boolean=true;

  constructor(private auditsService: AuditService) { }

  ngOnInit(): void {
    this.getAllContacts();
  }
  allAudits:any[]=[];
  getAllContacts() {
    this.auditLoading = true;
    this.auditsService.getAuditsAccount();
    this.auditsService.auditsSubject.subscribe((response: any) => {
      this.auditLoading = false;
      if(response.code=="6275d760a1b420ab70ec63a8f880e129"){
        this.allAudits = response.audits;
        this.allAudits.sort((a, b) => {
            const dateA = new Date(a.actionDate).getTime();
            const dateB = new Date(b.actionDate).getTime();
            return dateB - dateA ;
          });
        setTimeout(() => {
          (<any>$("#audit_table")).DataTable( {
            "destroy":true,
            "pagingType": "full_numbers",
            "scrollX": '400px',
            "scrollCollapse": true,
            "aaSorting": [],
            "iDisplayLength": 10,
            "autoWidth": true,
            "language": {
              "sProcessing": "Traitement en cours ...",
              "sLengthMenu": "Afficher _MENU_ lignes",
              "sZeroRecords": "Aucun résultat trouvé",
              "sEmptyTable": "Aucune donnée disponible",
              "sInfo": "",
              "sInfoEmpty": "",
              searchPlaceholder: "Saisir un mot clé",
              "sInfoFiltered": "",
              "sInfoPostFix": "",
              "sSearch": "Rechercher:",
              "sUrl": "",
              "sInfoThousands": ",",
              "sLoadingRecords": "Chargement...",
              "oPaginate": {
                "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
              },
              "oAria": {
                "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
              }
            },
            drawCallback: function () {
              // (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
              //       type: 'line',
              //       width: '60',
              //       height: '20',
              //       lineColor: '#1a73e9',
              //       fillColor: '#c2d5ff',
              //       spotColor: 'transparent',
              //       minSpotColor: 'transparent',
              //       maxSpotColor: 'transparent',
              //       highlightSpotColor: 'transparent',
              //       highlightLineColor: 'transparent',
              //   });
            }
          });
        }, 1000);
      }
    });
  }

}
